export default class ViewStyle {
}
ViewStyle.Diagram = 'Diagram';
ViewStyle.Design = 'Design';
ViewStyle.AllStyles = [ViewStyle.Diagram, ViewStyle.Design];
